import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

import Error from "@/components/system/Error.vue";
import {UserService} from "@/utilities/services/entities/UserService";
import {MiscService} from "@/utilities/system/services/entities/MiscService";
import {ErrorLocationType, PreferenceType} from "@/utilities/system/enums/Enums";
import {useSystemStore} from "@/stores/system/SystemStore";
import {UserPreference} from "@/models/system/user/UserPreference";
import {GeneralResponse} from "@/models/system/api/Responses";
import ErrorHandler from "@/utilities/system/helpers/ErrorHandler";
import {$t, i18n} from "@/utilities/system/i18n/config";
import {onMounted} from "vue";
import NullOrUndefinedHelper from "@/utilities/system/helpers/NullOrUndefinedHelper";
import OAuthService from "@/utilities/system/services/OAuthService";
import {Profile, User} from "oidc-client";
import router from "@/router";
import {notify} from "@kyvg/vue3-notification";
import jwt_decode from "jwt-decode";


export default /*#__PURE__*/_defineComponent({
  __name: 'OAuthCallback',
  setup(__props) {

const systemStore = useSystemStore();
const userService = new UserService();
const miscService = new MiscService();

const setUserSettings = async(userId:string)=> {
  // get filters for user
  const filterResp = await userService.getUserPreferences(userId, PreferenceType.filter, ErrorLocationType.login);
  // get hiddenColumns for User
  const columnResp = await userService.getUserPreferences(userId, PreferenceType.hiddenColumn, ErrorLocationType.login);
  // get general settings for User
  const genSetResp = await userService.getUserPreferences(userId, PreferenceType.general, ErrorLocationType.login);
  // get columnOrder settings for User
  const colOrderResp = await userService.getUserPreferences(userId, PreferenceType.columnOrder, ErrorLocationType.login);

  if (filterResp && columnResp && genSetResp && colOrderResp) {
    systemStore.setUserPreferences({
      userFilters: filterResp ?? [],
      userHiddenColumns: columnResp ?? [],
      userColumnOrder: colOrderResp ?? [],
      general: {
        darkMode: genSetResp.find((pi: UserPreference) => pi.attributeName === "darkMode")?.attributeValue ?? false,
        userStartPage: genSetResp.find((pi: UserPreference) => pi.attributeName === "userStartPage")?.attributeValue ?? "/account",
        userLocale: genSetResp.find((pi: UserPreference) => pi.attributeName === "userLocale")?.attributeValue ?? "de",
      },
    });

    // set language. if not null or undefined fallback to DE
    // @ts-expect-error
    i18n.global.locale.value = systemStore.userPreferences.general.userLocale;
  } else {
    ErrorHandler.handleError(new GeneralResponse(6666, "Ihre Einstellungen konnten nicht geladen werden"), ErrorLocationType.table);
  }
}

onMounted(async ()=> {
  try {
    const clientId = systemStore.settings.startupConfig?.clientId as string;
    const scopes = systemStore.settings.startupConfig?.clientScopes as string;
    const metaDataUrl = systemStore.settings.startupConfig?.metaDataUrl;
    const metaData = !NullOrUndefinedHelper(metaDataUrl) ? await miscService.getOidcMetaData(metaDataUrl as string) : undefined;
    const callbackUrls = systemStore.getCallbackUrls();
    const ssoCallback = callbackUrls.normal;
    const ssoSilentCallback = callbackUrls.silent;
    
    // dont get default instance since config can point to custom auth
    const oAuthService = new OAuthService(systemStore.getAuthorityUrl(), clientId, scopes, ssoCallback, ssoSilentCallback, metaData);
    
    const userManager = oAuthService.userManager;

    const oAuthUser = await userManager.signinRedirectCallback() as User;
    
    const userResp = await userService.getUserById(jwt_decode<Profile>(oAuthUser.access_token).sub, ErrorLocationType.login);
    if(!userResp) return;

    try {
      systemStore.setUser(userResp);
    }
    catch (e) {
      console.log("set user", e)
    }
    try {
      await setUserSettings(userResp.id);
    }
    catch (e) {
      console.log("set user settings", e)
    }

    await router.push(systemStore.userPreferences.general.userStartPage ?? "/account");

    notify({
      title: "Erfolg",
      text: $t('login.notifySuccessfulLogin'),
      duration: 5000,
      type: "success"
    });
  }
  catch (e){
    console.error("Login failed:", e)
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(" Waiting "),
    (_ctx.error)
      ? (_openBlock(), _createBlock(Error, {
          key: 0,
          errorLoc: _unref(ErrorLocationType).login
        }, null, 8, ["errorLoc"]))
      : _createCommentVNode("", true)
  ]))
}
}

})